import { BaseModel } from './base';

export class IncidentType extends BaseModel {
  name: string;
  siteId: string;
  subscriberId: string;
}
